/**
 * Moduł sterujący dolną belką porownywarki produktow,
 * odpowiada m.in. za aktualizacje produktów na belce
 */
app.service('comparisonBar', function(comparisonState, modal, loading, comparisonButtonManager, broker, html){
	let $self, $container, $productListWrapper, $productList, $goToCompareButton, $countText, $popover;
	let $mobileAppComparisonButton;
	let isExpanded = false;
	const MAX_VISIBLE_PRODUCT_TILES = comparisonState.getMaxVisible();
	const MAX_PRODUCTS_PER_GROUP = comparisonState.getMaxProductsPerGroup();

	function setElements() {
		$self = $('#comparison-bar');
		$container = $('.comparison-bar-container', $self);
		$productListWrapper = $('.product-tile-list-wrapper', $self);
		$productList = $('.product-tile-list', $self);
		$goToCompareButton = $('.js-go-to-compare-from-bar', $self);
		$countText = $('.js-comparison-count-text', $self);
		$popover = $('.comparison-groups-popover', $self);
		$mobileAppComparisonButton = $('.js-app-bar-action-compared');
	}
	function showMobileAppComparisonCount() {
		// metoda do aktualizacji licznika produktów w porównaniu w belce pod aplikację mobilną
		if ($mobileAppComparisonButton.length === 0) {
			return;
		}
		const comparisonProductsCount = comparisonState.getAllProducts()?.length || 0;
		if (comparisonProductsCount > 0) {
			$mobileAppComparisonButton.attr('data-count', comparisonProductsCount); // Aktualizacja licznika porównywanych produktów
		}
	}

	// Firstly 'collapsed', after user action 'expanded'.
	function setBarState() {
		const allItems = comparisonState.getAllProducts();
		
		if (allItems.length === 0) {
			html.remove('comparison-bar-collapsed');
			html.remove('comparison-bar-expanded');
			$self.removeClass('visible');
			$container.removeClass('expanded collapsed');
			isExpanded = false; // reset
			return;
		}
		showMobileAppComparisonCount();

		$self.addClass('visible');

		if (!isExpanded) {
			updateCountTextOnCollapsedBar(allItems.length);
			html.add('comparison-bar-collapsed');
			$container.addClass('collapsed');
			$container.removeClass('expanded');
			isExpanded = true;
		} else {
			html.remove('comparison-bar-collapsed');
			html.add('comparison-bar-expanded');
			$container.addClass('expanded');
			$container.removeClass('collapsed');
		}
	}

	function redirectToComparison(products) {
		const url = `/porownywarka.bhtml?plu=${products.join(',')}`;

		loading.redirect(url);
	}

	function compare() {
		const groups = comparisonState.getGroups();
		
		if (groups.length > 1) {
			handleGroupsPopover();
			togglePopoverVisibility();
			return;
		}
		
		const currentGroup = groups[0];
		UA.interaction('Belka', 'Porównanie', 'Do porównania');
		const products = comparisonState.getProductsByGroup(currentGroup);
		redirectToComparison(products);
	}

	function compareMoreTile() {
		const allItems = comparisonState.getAllProducts();
		const nextItem = allItems[MAX_VISIBLE_PRODUCT_TILES];
		const groupName = nextItem.groupName;
		UA.interaction('Belka', 'Porównanie', 'Do porównania - kafelek +1');
		const products = comparisonState.getProductsByGroup(groupName);
		redirectToComparison(products);
	}

	function setEvents() {
		$goToCompareButton.on('click', compare);
		$mobileAppComparisonButton.on('click', compare);

		$self.on('click', '.js-toggle-comparison-bar', function() {
			setBarState();
			UA.interaction('Belka', 'Porównanie', 'Rozwiń belkę');
		}).on('click', '.js-delete-product', function() {
			const $productTile = $(this).closest('.product-tile');
			const product = $productTile.attr('data-plu');
			const category = $productTile.data('category');
			removeProduct(product, category);
			UA.interaction('Belka', 'Porównanie', 'Usuń produkt');
		}).on('click', '.js-group-remove', function() {
			const groupName = $(this).data('group');
			removeGroup(groupName);
			UA.interaction('Belka', 'Porównanie', 'Usuń grupę');
		}).on('click', '.js-group-compare', function() {
			const groupName = $(this).data('group');
			const products = comparisonState.getProductsByGroup(groupName);
			UA.interaction('Belka', 'Porównanie', 'Do porównania z grupy');
			redirectToComparison(products);
		}).on('click', '.comparison-more-tile', function() {
			compareMoreTile();
		});

		$('body').on('click', function(e) {
			if ($popover.hasClass('visible') && !$(e.target).closest($goToCompareButton).length && !$(e.target).closest('.comparison-groups-popover').length) {
				hideGroupsPopover();
			}
		});

		// Listen to broker events from comparisonButtonManager
		broker.on('COMPARISON_PRODUCT_TOGGLED', function() {
			setBarState();
			renderProductsList();
			handleGroupsPopover();
		});
		broker.on('COMPARISON_STORAGE_CHANGED', function() {
			setBarState();
			renderProductsList();
			handleGroupsPopover();
		});
	}

	
	function removeProduct(plu, category) {
		comparisonState.toggleProduct({ plu: plu, category: category });
		comparisonButtonManager.updateButtonState(plu, false);
		setBarState();
		renderProductsList();
	}

	// Functions for product list rendering - START
	function renderProductsList() {
		const allItems = comparisonState.getAllProducts();
		const visibleItems = allItems.slice(0, MAX_VISIBLE_PRODUCT_TILES);

		const existingTilesMap = new Map();
		$productList.find('.product-tile:not(.comparison-more-tile)').each(function() {
			existingTilesMap.set($(this).attr('data-plu'), $(this));
		});
		
		removeUnnecessaryTiles(visibleItems, existingTilesMap);
		updateTiles(visibleItems, existingTilesMap);
		updateMoreTile(allItems);
		updateGoToCompareButtonState();
	}

	function removeUnnecessaryTiles(visibleItems, existingTilesMap) {
		existingTilesMap.forEach(function($tile, plu) {
			const isVisible = visibleItems.some(item => item.id === plu);

			if (!isVisible) {
				$tile.remove();
			}
		});
	}

	function updateTiles(visibleItems, existingTilesMap) {
		visibleItems.forEach((item, index) => {
			const $existingItem = existingTilesMap.get(item.id);

			if (!$existingItem) {
				insertNewProductTile(item, index);
			} else {
				setProductTilePosition($existingItem, index);
			}
		});
	}

	function insertNewProductTile(item, index) {
		const $newItem = createProductTile(item);
		if (index === 0) {
			$productList.prepend($newItem);
		} else {
			const $prevItem = $productList.find('.product-tile:not(.comparison-more-tile)').eq(index - 1);
			if ($prevItem.length) {
				$prevItem.after($newItem);
			} else {
				const $moreTile = $productList.find('.comparison-more-tile');
				if ($moreTile.length) {
					$moreTile.before($newItem);
				} else {
					$productList.append($newItem);
				}
			}
		}
	}

	function setProductTilePosition($item, index) {
		const currentIndex = $productList.find('.product-tile:not(.comparison-more-tile)').index($item);
		if (currentIndex !== index) {
			if (index === 0) {
				$productList.prepend($item);
			} else {
				const $prevItem = $productList.find('.product-tile:not(.comparison-more-tile)').eq(index - 1);
				$prevItem.after($item);
			}
		}
	}

	function updateMoreTile(allItems) {
		const totalCount = allItems.length;
		let $moreTile = $productList.find('.comparison-more-tile');
		
		if (totalCount > MAX_VISIBLE_PRODUCT_TILES) {
			const diff = totalCount - MAX_VISIBLE_PRODUCT_TILES;
			const nextItem = allItems[MAX_VISIBLE_PRODUCT_TILES];
			
			if ($moreTile.length === 0) {
				$moreTile = $('<li class="product-tile comparison-more-tile" role="button" tabindex="0"></li>');
				$productList.append($moreTile);
			}
			
			const $img = $('<img>').attr({
				src: nextItem.thumbnail,
				alt: nextItem.name
			});
			const $counter = $('<span class="counter"></span>').text('+' + diff);
			$moreTile.empty().append($img, $counter);
		} else {
			$moreTile.remove();
		}
	}

	function updateGoToCompareButtonState() {
		const groups = comparisonState.getGroups();
		
		if (groups.length > 1) {
			$goToCompareButton.addClass('multi-group').text('Porównania')
				.attr({
					'aria-haspopup': 'true',
					'aria-expanded': 'false',
					'aria-label': 'Rozwiń listę porównań według kategorii produktów.'
				})
		} else {
			$goToCompareButton.removeClass('multi-group active').text('Porównaj')
				.attr('aria-label', 'Otwórz okno ze szczegółami porównania.')
				.removeAttr('aria-haspopup', 'aria-expanded')
		}
	}

	function createProductTile(item) {
		const $li = $('<li class="product-tile"></li>');
		const $img = $('<img>').attr({
			src: item.thumbnail,
			alt: item.name
		});
		const $button = $('<button class="comparison-delete-btn js-delete-product" type="button" title="Usuń z porównania"></button>')
						.attr('aria-label', 'Usuń z porównania produkt ' + item.name);
		$li.append($img, $button);
		$li.attr({
			'data-plu': item.id,
			'data-category': item.groupName
		});
		return $li;
	}
	// Functions for product list rendering - END

	// Popover functions - START
	function renderGroupsPopover() {
		const groups = comparisonState.getGroups();
		const $list = $popover.find('ul');
		$list.empty();

		const sortedGroups = groups.slice().sort((a, b) => a.localeCompare(b, 'pl'));

		$.each(sortedGroups, function(i, groupName) {
			const products = comparisonState.getProductsByGroup(groupName);
			const count = products.length;
			const name = comparisonState.getGroupPresentationName(groupName) || groupName;
			const $li = $('<li></li>');
			
			// Generate screen reader text: "Smartfony i telefony (3 z 5)"
			const $removeBtn = $('<button class="group-remove js-group-remove"></button>')
				.attr({
					'data-group': groupName,
					'type': 'button',
					'title': 'Usuń grupę ' + name,
				});
				
			const $info = $('<div class="group-info" aria-hidden="true"></div>').text(`${name} (${count}/${MAX_PRODUCTS_PER_GROUP})`);
			$info.prepend($removeBtn);
			
			const $compareBtn = $('<button class="group-compare-btn js-group-compare">Porównaj</button>')
				.attr({
					'data-group': groupName,
					'type': 'button',
					'title': 'Porównaj produkty z grupy ' + name,
				});
			
			$li.append($info).append($compareBtn);
			$list.append($li);
		});
	}

	function togglePopoverVisibility() {
		$popover.toggleClass('visible');
		$goToCompareButton.toggleClass('active');
		const isVisible = $popover.hasClass('visible');
		$goToCompareButton.attr('aria-expanded', isVisible);
	}

	function hideGroupsPopover() {
		$popover.removeClass('visible');
		$goToCompareButton.removeClass('active');
		if ($goToCompareButton.hasClass('multi-group')) {
			$goToCompareButton.attr('aria-expanded', 'false');
		}
	}

	function handleGroupsPopover() {
		const groups = comparisonState.getGroups();
		if (groups.length > 1) {
			renderGroupsPopover();
		} else {
			hideGroupsPopover();
		}
	}

	function removeGroup(groupName) {
		const presentationName = comparisonState.getGroupPresentationName(groupName);
		modal.generate({
			header: 'Czy na pewno chcesz wyczyścić porównanie?',
			content: `<p>Usuniemy z porównania wszystkie produkty z kategorii ${presentationName || groupName}. Aby ponownie je porównać, trzeba będzie jeszcze raz wyszukać produkty i je dodać.</p>`,
			id: 'delete-group-from-comparison',
			buttons: [
				{
					text: 'Wróć do porównania',
					cssClass: 'button-cancel',
					click: function () {
						modal.close();
					}
				},
				{
					text: 'Wyczyść',
					cssClass: 'button-remove-group',
					click: function () {
						modal.close();
						comparisonState.removeGroup(groupName);
						comparisonButtonManager.syncAllButtons();
						handleGroupsPopover();
						renderProductsList();
					}
				}
			]
		});
	}
	// Popover functions - END

	function updateCountTextOnCollapsedBar(count) {
		let text = 'Masz ' + count;
		if (count === 1) {
			text += ' produkt w porównaniu';
		} else if (count % 10 >= 2 && count % 10 <= 4 && (count < 10 || count > 20)) {
			text += ' produkty w porównaniu';
		} else {
			text += ' produktów w porównaniu';
		}
		$countText.text(text);
		
		const ariaLabel = 'Pasek porównywarki. Liczba produktów w porównaniu: ' + count + '. Rozwiń belkę porównania';
		$self.find('.comparison-expand-btn').attr('aria-label', ariaLabel);
	}

	function init() {
		setElements();
		if ($self.length) {
			setEvents();
			setBarState();
			renderProductsList();
		}
	}

	return {
		init,
	};
});
